import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from '../../hooks/useToken';

const ModalActivarNube = ({
    licencias,
    cicloFacturacion,
    idLicencia,
    setShowModalActivarNube,
    showModalActivarNube,
    usuariosNube,
    setUsuariosNube
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const { register, reset, handleSubmit, formState: { errors } } = useForm();
    const [procesandoModal, setProcesandoModal] = useState(false);

    /**
     * Submit de activar
     * @param {any} data
     */
    const onSubmitActivar = data => {
        setProcesandoModal(true);
        if (data.idCatCicloFacturacion == 4 && licencias.idCatTipoLicencia == 3) {
            showErrorToast('No es posible asignar un ciclo de facturación permanente a este tipo de licencia');
            setProcesandoModal(false);
        }
        else
            activarLicencia(JSON.stringify(data));
    };

    /**
     * Activar licencia
     * @param {any} values
     */
    const activarLicencia = async (values) => {
        console.log(values);
        const response = await fetch("/api/licencia/activarlicencia/?id=" + idLicencia + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {

                showSuccessToast(data["table1"][0].vMessage);

                //se actualizan unicamente los campos modificados.
                licencias.bIsPeriodoPrueba = data["table2"][0].bIsPeriodoPrueba;
                licencias.dUpdatedDate = data["table2"][0].dUpdatedDate;
                licencias.vUpdatedUser = data["table2"][0].vUpdatedUser;
                licencias.dInicioLicenciaUso = data["table2"][0].dInicioLicenciaUso;
                licencias.dDiasTranscurridos = data["table2"][0].dDiasTranscurridos;
                licencias.dFinLicenciaUso = data["table2"][0].dFinLicenciaUso;
                licencias.dDiasFaltantes = data["table2"][0].dDiasFaltantes;
                licencias.idCatCicloFacturacion = data["table2"][0].idCatCicloFacturacion;
                licencias.vLatLon = data["table2"][0].vLatLon;
                licencias.vConfiguracion = data["table2"][0].vConfiguracion;

                setUsuariosNube(data["table3"]);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActivarNube(false);
        setProcesandoModal(false);
        reset();
    };

    const ObtenerListaUsuariosNubeAkasia = async () => {

        const response = await fetch("/api/licencia/ObtenerListaUsuariosNubeAkasia/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            console.log(response);
            const data = await response.json();

            setUsuariosNube(data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    return (
        showModalActivarNube &&
        <Modal
            show={showModalActivarNube}
            onHide={() => setShowModalActivarNube(false)}
            onShow={ObtenerListaUsuariosNubeAkasia}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmitActivar)}>
                <Modal.Header>
                    <Modal.Title>Activar Licencia {licencias.vDescripcionTipo}</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalActivarNube(false); reset() }} />

                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Verifica y completa la siguiente informaci&oacute;n.
                            <hr></hr>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} lg={12} xs={12} sm="{12}">
                            <Form.Label>Fecha Inicio de Licencia</Form.Label>
                            <Form.Group className="mb-3">
                                <Form.Control
                                    type="date"
                                    {...register("dInicioLicenciaUso",
                                        {
                                            required: true
                                        })
                                    }
                                    isInvalid={!!errors.dInicioLicenciaUso} />

                                <Form.Control.Feedback type="invalid">
                                    {errors.dInicioLicenciaUso && errors.dInicioLicenciaUso.message}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Ciclo facturaci&oacute;n</Form.Label>
                                <Form.Select
                                    aria-label="Default select"
                                    defaultValue={licencias.idCatCicloFacturacion}
                                    isInvalid={!!errors.idCatCicloFacturacion}
                                    {...register("idCatCicloFacturacion",
                                        {
                                            required: true
                                        })
                                    }
                                >
                                    {cicloFacturacion.map((ciclo, index) => {
                                        return (<option key={index} value={ciclo.idCatCicloFacturacion}>{ciclo.vDescripcionCiclo} - {ciclo.iNumeroDias} d&iacute;as</option>)
                                    })}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    {errors.idCatCicloFacturacion && errors.idCatCicloFacturacion.message}
                                </Form.Control.Feedback>
                            </Form.Group>

                        </Col>
                    </Row>
                    {licencias.idCatTipoLicencia == 3 &&
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Usuario Nube Akasia</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        isInvalid={!!errors.idUsuarioNubeAkasia}
                                        {...register("idUsuarioNubeAkasia",
                                            {
                                                required: true
                                            })
                                        }
                                    >
                                        {usuariosNube.map((una, index) => {
                                            return (<option key={index} value={una.idUsuarioNubeAkasia}>{una.vNombre} </option>)
                                        })}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.idUsuarioNubeAkasia && errors.idUsuarioNubeAkasia.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalActivarNube(false); reset() }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="submit" variant='success' >A C T I V A R</Button>}
                </Modal.Footer>
            </Form>
        </Modal>

    )
}

ModalActivarNube.propTypes = {

    idLicencia: PropTypes.string,
    licencias: PropTypes.object,
    setShowModalActivarNube: PropTypes.func,
    cicloFacturacion: PropTypes.array,
    showModalActivarNube: PropTypes.bool,
    usuariosNube: PropTypes.array,
    setUsuariosNube: PropTypes.func
};

export default ModalActivarNube;

